import { VaroCategories } from 'shared/analytics/types/categories';

export const VaroListItemNames = {
  ACCOUNT_MANAGEMENT: {
    LEGAL_AGREEMENTS: 'legal_agreements',
    MANAGE_ACCOUNTS: 'manage_accounts',
    PERSONAL_DETAILS: 'personal_details',
    STATEMENTS_AND_DOCUMENTS: 'statements_and_documents',
  },
  REFERRAL: {
    INVITE_FRIENDS: 'invite_friends',
  },
  SERVICING: {
    DISPUTES: 'disputes',
    HELP_AND_SUPPORT: 'help_and_support',
  },
  SETTINGS: {
    NOTIFICATION_SETTINGS: 'notification_settings',
  },
} as const satisfies Partial<
  Record<keyof typeof VaroCategories, Record<string, string>>
>;

export type VaroListItemName = {
  [
    K in keyof typeof VaroListItemNames
  ]: (typeof VaroListItemNames)[K][keyof (typeof VaroListItemNames)[K]];
}[keyof typeof VaroListItemNames];
